import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/45b021a8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import OverviewCard from 'components/OverviewCard';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Start by identifying the purpose of the visualization and choose a chart type appropriately.`}</p>
    </PageDescription>
    <h2>{`Comparisons`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Bar chart" href="/data-visualization/basic-charts#bar-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/ead52888035f8edc84ed64c5442d791d/bar.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Grouped bar" href="/data-visualization/basic-charts#grouped-bar-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/b1ecb10fed9a076af501480ed2dc4d2c/bargrouped.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Bubble chart" href="/data-visualization/basic-charts#bubble-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/c91bbf38873920665b668f7ae91d6ed3/bubble.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Radar chart" disabled mdxType="OverviewCard">
          <img {...{
            "src": "/6d40736d54808c47a1bf43bec715546c/radar.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Horizontal bar" href="/data-visualization/basic-charts#horizontal-bar" mdxType="OverviewCard">
          <img {...{
            "src": "/7b17f5b1b56594939dcc9a1b79b6f2a7/barhoriz.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>
    <h2>{`Trends`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Line chart" href="/data-visualization/basic-charts#line-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/a7520c466e27fb3a8880d5cfaca4ae27/line.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Area chart" href="/data-visualization/basic-charts#area-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/06ae15c0e3fd9cb519afd524874f6111/area.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Histogram" href="/data-visualization/basic-charts#bar-chart" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/48409f951f64c4cb72ca74d47bb53317/histogram.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Stream chart" disabled mdxType="OverviewCard">
          <img {...{
            "src": "/e1b6d0454fdc9a5e825fa8b85f9427e6/stream.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>
    <h2>{`Part-to-whole`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Donut / pie" href="/data-visualization/basic-charts#pie-and-donut-chart" mdxType="OverviewCard">
          <img {...{
            "src": "/e0f72c933c56f9a181871c256bec5aaf/donut.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Stacked bar" href="/data-visualization/basic-charts/#stacked-bar" mdxType="OverviewCard">
          <img {...{
            "src": "/c50e52469e97e742bc6271def579647a/barstack.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Stacked area" href="/data-visualization/basic-charts/#stacked-area-chart" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/6acc9cb91a5803e9b90ecff8baa48345/areastack.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Tree map" disabled mdxType="OverviewCard">
          <img {...{
            "src": "/e03c1051a172dd58c2b1d6b3a055c0e0/treemap.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
        <OverviewCard title="Meter / gauge" href="/data-visualization/basic-charts/#meter-and-gauge" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/4e7fcb18a379645fc847c58465368923/gauge.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>
    <h2>{`Correlations`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Scatter plot" href="/data-visualization/basic-charts#scatter-plot" mdxType="OverviewCard">
          <img {...{
            "src": "/de4f62005a3c2d92c310a1b2ff79f1f1/scatter.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Heat map" disabled mdxType="OverviewCard">
          <img {...{
            "src": "/8d15fb34361497924e931f3a1edb6891/heatmap.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Parallel coordinates" disabled mdxType="OverviewCard">
          <img {...{
            "src": "/23fd1e631818fcc3848017d99092039f/parallel.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>
    <h2>{`Connections`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Alluvial diagram" href="/data-visualization/advanced-charts#alluvial-diagram" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/70db59f6404b2c433747a268566dcb50/alluvial.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Tree diagram" href="/data-visualization/advanced-charts#tree-diagram" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/c3ac6fe319c73f21f0a8757bcf6ddcc9/treediagram.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>
    <h2>{`Geospatial: overlays`}</h2>
    <Row className="overview-card-group" mdxType="Row">
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Choropleth map" href="/data-visualization/advanced-charts#choropleth-map" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/b012737e6d46b33f3884caccb24d46f1/geo-choropleth.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Proportional symbol" href="/data-visualization/advanced-charts#proportional-symbol" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/18b50f638615bda17f1eb3948b87c61a/geo-proportion.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
      <Column colMax={3} colXl={3} colLg={4} colMd={4} colSm={2} noGutterSm mdxType="Column">
 <OverviewCard title="Connecting lines" href="/data-visualization/advanced-charts#connecting-lines" tag="Design only" mdxType="OverviewCard">
          <img {...{
            "src": "/54e7d3cc279ad20787d91b7763e88202/geo-connection.svg",
            "alt": null
          }}></img>
        </OverviewCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      